import {cmp, diff} from 'lib/utilities/functions';

export default function TweenValue(fromValue, speed, maxVel = Infinity) {
    let dest = fromValue;
    let cur = fromValue;

    function to(newDest) {
        dest = newDest;
    }

    function from_to(from, to) {
        cur = from;
        dest = to;
    }

    function force(to) {
        from_to(to, to);
    }

    function ended() {
        return distance() === 0;
    }

    /**
     * Get the remaining distance.
     *
     * @return {*}
     */
    function distance() {
        return diff(cur, dest);
    }

    function current() {
        return cur;
    }

    function update(tDelta) {
        // Get absolute diff
        const delta = diff(cur, dest);

        // If there's no change, or if the remaining distance is less than 0.1, jump to the destination so we don't just
        // keep get infinitesimally closer, as the velocity is proportional to the distance.
        if (delta === 0 || delta < 0.1) {
            cur = dest;
        } else {
            // Bound the velocity by a maximum
            const vel = Math.min(maxVel, delta * speed);

            // Get the distance that should have been travelled in the time since the last update
            const distance = vel / 1000 * tDelta;

            // Then multiply distance by the direction of travel
            cur += distance * cmp(dest, cur);
        }

        return cur;
    }

    return {
        ended,
        distance,
        current,
        from_to,
        to,
        force,
        update
    }
}